import React from "react";

export default function Field({
  label,
  value,
  editable = false,
  onChange,
  name,
  show = true,
  type = "text",
  textarea = false
}) {
  if (!show) return null;

  return (
    <div className="bg-gray-50 border border-gray-100 rounded-lg p-3">
      <label className="block text-xs text-gray-500 mb-1">{label}</label>

      {editable ? (
        textarea ? (
          <textarea
            name={name}
            value={value}
            onChange={onChange}
            className="w-full p-2 rounded-md border"
            rows={4}
          />
        ) : (
          <input
            name={name}
            value={value}
            onChange={onChange}
            type={type}
            className="w-full p-2 rounded-md border"
          />
        )
      ) : (
        <div className="text-sm text-gray-700">{String(value)}</div>
      )}
    </div>
  );
}
